export const appSettings = {
  name: 'Sanitop Screen',
  description: "",
  layout: "vertical",
  logo: {
    url: "/logo.png",
    alt: "sanitop-logo",
    href: "/",
    width: 300,
    height: 100,
  },
  logoMobile: {
    url: "",
    alt: "",
    href: "/",
    width: 512,
    height: 512,
  },
  defaultLanguage: "pt",
  author: {
    name: "Purple Profile",
    websiteUrl: "https://purpleprofile.pt",
    address: "",
  },
  socket: {
    active: false,
    reconnect: true,
    attemps: false,
    timer: 60 //Time in seconds
  },
  toast: {
    className: 'bg-white text-lg',
    success: {
      className: 'bg-white text-lg',
      style: {
        maxWidth: 1000
      },
      duration: 5000,
    },
    error: {
      className: 'bg-white text-lg',
      style: {
        maxWidth: 1000
      },
      duration: 5000
    },
  }
}